"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toolbar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _global = require("global");

var _bar = require("../bar/bar");

var _icon = require("../icon/icon");

var _button = require("../bar/button");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2 =
/*#__PURE__*/
_react["default"].createElement(_icon.Icons, {
  icon: "zoom"
});

var _ref3 =
/*#__PURE__*/
_react["default"].createElement(_icon.Icons, {
  icon: "zoomout"
});

var _ref4 =
/*#__PURE__*/
_react["default"].createElement(_icon.Icons, {
  icon: "zoomreset"
});

var Zoom = function Zoom(_ref) {
  var zoom = _ref.zoom,
      resetZoom = _ref.resetZoom;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_button.IconButton, {
    key: "zoomin",
    onClick: function onClick(e) {
      e.preventDefault();
      zoom(0.8);
    },
    title: "Zoom in"
  }, _ref2), _react["default"].createElement(_button.IconButton, {
    key: "zoomout",
    onClick: function onClick(e) {
      e.preventDefault();
      zoom(1.25);
    },
    title: "Zoom out"
  }, _ref3), _react["default"].createElement(_button.IconButton, {
    key: "zoomreset",
    onClick: function onClick(e) {
      e.preventDefault();
      resetZoom();
    },
    title: "Reset zoom"
  }, _ref4));
};

var _ref6 =
/*#__PURE__*/
_react["default"].createElement(_icon.Icons, {
  icon: "share"
});

var Eject = function Eject(_ref5) {
  var baseUrl = _ref5.baseUrl,
      storyId = _ref5.storyId;
  return _react["default"].createElement(_button.IconButton, {
    key: "opener",
    onClick: function onClick() {
      return _global.window.open("".concat(baseUrl, "?id=").concat(storyId));
    },
    title: "Open canvas in new tab"
  }, _ref6);
};

Eject.displayName = "Eject";
var Bar = (0, _theming.styled)(function (props) {
  return _react["default"].createElement(_bar.FlexBar, props);
})({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  transition: 'transform .2s linear'
});

var Toolbar = function Toolbar(_ref7) {
  var storyId = _ref7.storyId,
      baseUrl = _ref7.baseUrl,
      zoom = _ref7.zoom,
      resetZoom = _ref7.resetZoom,
      rest = _objectWithoutProperties(_ref7, ["storyId", "baseUrl", "zoom", "resetZoom"]);

  return _react["default"].createElement(Bar, rest, _react["default"].createElement(_react.Fragment, {
    key: "left"
  }, _react["default"].createElement(Zoom, {
    zoom: zoom,
    resetZoom: resetZoom
  })), _react["default"].createElement(_react.Fragment, {
    key: "right"
  }, storyId && _react["default"].createElement(Eject, {
    storyId: storyId,
    baseUrl: baseUrl
  })));
};

exports.Toolbar = Toolbar;
Toolbar.displayName = "Toolbar";